var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid-item3"},[(_vm.view)?_c('liveAgents',{ref:"liveAgentsRef",on:{"toggleSubDrawer":function($event){return _vm.toggle_controll($event)}}}):_c('liveCalls',{ref:"liveCallsRef",on:{"toggleSubDrawer":function($event){return _vm.toggle_controll($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }